import { render, staticRenderFns } from "./UpdateCategoryModal.vue?vue&type=template&id=3868f681"
import script from "./UpdateCategoryModal.vue?vue&type=script&lang=js"
export * from "./UpdateCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports